<template>
  <div v-for="(item,index) in userLogList" :key="index" style="margin: 12px 0;">
    <span>{{item.createTime}}</span>
    <p><span style="margin-right: 10px;">{{item.content}}</span><el-tag size="small">{{item.name}}</el-tag></p>
  </div>
</template>

<script>
export default {
name: "UserLog",
  props: {
    userLogList: {
      type: Array,
      default: [],
    }
  }
}
</script>

<style scoped>

</style>
